{
	"showButtonTitle": "Vis",
	"hideButtonTitle": "Skjul"
}
